import { createFileRoute } from "@tanstack/react-router";
import ContactsPage, { type ContactsSort } from "@/site/pages/contacts";

// Old app's contacts list lived at /address_book (route "my-contacts") — keep the URL.
interface ContactsSearch {
  /** Omitted = last-name sort, matching the old app's default. */
  sort?: ContactsSort;
  group?: string;
  /** Contact id whose edit dialog is open (deep-linkable, like the old app). */
  edit?: string;
}

export const Route = createFileRoute("/address_book")({
  validateSearch: (search: Record<string, unknown>): ContactsSearch => {
    const out: ContactsSearch = {};
    if (search.sort === "first" || search.sort === "next") out.sort = search.sort;
    if (typeof search.group === "string" && search.group) out.group = search.group;
    if (typeof search.edit === "string" && search.edit) out.edit = search.edit;
    return out;
  },
  component: ContactsPage,
});
